import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMailQuestion } from "@tabler/icons-react";
import { SolicitudesRuteoDef } from "./SolicitudesRuteoDef";

export const SolicitudesRuteoIcon = IconMailQuestion;
export const SolicitudesRuteoHelpText = '* Las solicitudes de ruteo permiten solicitar nuevas rutas o modificar existentes';

export class SolicitudesRuteo extends Entity<SolicitudesRuteoDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new SolicitudesRuteoDef(), parentKeys);
        this.Form = import('./SolicitudesRuteoForm').then((module) => module.SolicitudesRuteoForm);
        this.Title = "Solicitudes de Ruteo";
        this.HelpText = SolicitudesRuteoHelpText;
        this.Icon = SolicitudesRuteoIcon;
    }
}

export class SolicitudesRuteoDetalles extends Entity<SolicitudesRuteoDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new SolicitudesRuteoDef(), parentKeys);
        this.Form = import('./SolicitudesRuteoDetallesForm').then((module) => module.SolicitudesRuteoDetallesForm);
        this.Title = "Solicitudes de Ruteo Detalles";
        this.HelpText = SolicitudesRuteoHelpText;
        this.Icon = SolicitudesRuteoIcon;
    }
}